// extracted by mini-css-extract-plugin
export var borderRadius = "_5m-4";
export var large = "_5m-3";
export var logoContainer = "_5m-0";
export var nameLogo = "_5m-2";
export var small = "_5m-1";